import style from './index.module.css'
import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import ScrollAnimation from 'react-animate-on-scroll';
import { Pagination } from 'swiper/modules';
export default function () {
  return (
    <div>
    <div className={style.about}>
      <div className={style.our}>
        <p><a href='/home'>Home</a>/<span>About Us</span></p>
        <h1>About Our Story</h1>
      </div>
      <div className={style.img}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/product/product-45.png'></img>
      </div>
    </div>
    <div className={style.abt}> 
      <div className={style.img1}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/about/about-01.png'></img>
      </div>
      <div className={style.text}>
        <p className={style.p}> <i className="fa-solid fa-cart-shopping"></i> About Store</p>
        <h3>Online shopping includes both buying things online.</h3>
        <p>Salesforce B2C Commerce can help you create unified, intelligent digital commerce experiences — both online and in the store</p>
        <p>Empower your sales teams with industry tailored solutions that support manufacturers as they go digital, and adapt to changing markets & customers faster by creating new business.
        Salesforce B2B Commerce offers buyers the seamless, self-service experience of online shopping with all the B2B
        </p>

      </div>
    </div>
    <div className={style.happy}>
      <div className={style.div}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/about/shape-01.png'></img>
        <h1>40,000+ Happy Customer</h1>
        <p>Empower your sales teams with industry tailored solutions that support.</p>
      </div>
      <div className={style.div}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/about/shape-02.png'></img>
        <h1>16 Years of Experiences</h1>
        <p>Empower your sales teams with industry tailored solutions that support.</p>
      </div>
      <div className={style.div}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/about/shape-03.png'></img>
        <h1>12 Awards Won</h1>
        <p>Empower your sales teams with industry tailored solutions that support.</p>
      </div>
    </div>
    <div className={style.team}>
    </div>
      <div className={style.team1}>
        <p className={style.pr}><i class="fa-solid fa-user-plus"></i> Our Team</p>
        <h2>Expart Management Team</h2>
        <Swiper
        slidesPerView={1}
        spaceBetween={10}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          '@0.00': {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          '@0.75': {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          '@1.00': {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          '@1.50': {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }}
        modules={[Pagination]}
        className={style.mySwiper}
      >
        <SwiperSlide> 
          <div className={style.team2}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/team/team-01.png'></img>
            <p>Founder</p>
            <h5>Rosalina D.Willson</h5>
          </div>
        </SwiperSlide>
        <SwiperSlide>
        <div className={style.team2}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/team/team-02.png'></img>
            <p>Ceo</p>
            <h5>Ukolilix X.Xilanorix</h5>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={style.team2}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/team/team-03.png'></img>
            <p>Designer</p>
            <h5>Alonso M.Miklonax</h5>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={style.team2}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/team/team-04.png'></img>
            <p>Designer</p>
            <h5>Rosalina D.Willson</h5>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={style.team2}>
            <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/team/team-03.png'></img>
            <p>Founder</p>
            <h5>Ukolilix X.Xilanorix</h5>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={style.team2}>
          <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/team/team-02.png'></img>
          <p>Ceo</p>
          <h5>Alonso M.Miklonax</h5>
          </div>
        </SwiperSlide>
      </Swiper>
      </div>
      <div className={style.abt1}> 
      <div className={style.img2}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/about/about-02.png'></img>
      </div>
      <div className={style.text1}>
        <p>Features #01</p>
        <h1>Solutions that work together</h1>
        <p>Publish your eCommerce site quickly with our easy-to-use store builder— no coding required. Migrate your items from your point of sale system or turn your Instagram feed into a shopping site and start selling fast. Square Online works for all kinds of businesses—retail, restaurants, services.</p>
        <a href=''>Get In Touch</a>
      </div>
    </div>
    <div className={style.abt2}> 
      <div className={style.text2}>
        <p>Features #01</p>
        <h1>Solutions that work together</h1>
        <p>Publish your eCommerce site quickly with our easy-to-use store builder— no coding required. Migrate your items from your point of sale system or turn your Instagram feed into a shopping site and start selling fast. Square Online works for all kinds of businesses—retail, restaurants, services.</p>
        <a href=''>Get In Touch</a>
      </div>
      <div className={style.img3}>
        <img src='https://new.axilthemes.com/demo/template/etrade/assets/images/about/about-03.png'></img>
      </div>
    </div>
  </div>
  )
}
